import styled from 'styled-components'

import type { FourColumnFeatureBlockRecord } from '@/types/datocms-schema'

import { Container } from '@/components/shared/Container'

import { FourColumnFeatureCard } from './FourColumnFeatureCard'

const StyledMainContainer = styled.section`
  padding: 56px 0 200px 0;
  text-align: center;
  background-color: ${(p) => p.theme.v2.surface.white};

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    padding: 80px 0;
  }
`

const StyledHeading = styled.div`
  margin-bottom: 60px;

  h2 {
    font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    color: ${(props) => props.theme.v2.onSurface.text};
    margin: 8px 24px;

    i {
      font-family: ${(p) => p.theme.v2.font.nantesItalic};
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    color: ${(props) => props.theme.v2.onSurface.subduedText};
    margin: 0;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin-bottom: 48px;
  }
`

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 40px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`
type FourColumnFeatureProps = {
  content: FourColumnFeatureBlockRecord
}

const HOW_IT_WORKS_FOUR_COLUMN_TITLE = 'Feel better, living the ZOE way'

const renderedHowItWorksFourColumnTitle = () => (
  <h2>
    Feel better, living the <i>ZOE way</i>
  </h2>
)
export const FourColumnFeature = ({ content }: FourColumnFeatureProps) => {
  const { preTitle, title, cards } = content
  return (
    <StyledMainContainer className="four-column-feature">
      <Container>
        <StyledHeading className="four-column-feature-heading">
          {preTitle && <p className="pre-title">{preTitle}</p>}
          {title && title === HOW_IT_WORKS_FOUR_COLUMN_TITLE ? renderedHowItWorksFourColumnTitle() : <h2>{title}</h2>}
        </StyledHeading>

        <StyledGrid className="four-column-feature-grid">
          {cards.map((card) => {
            const { id, title, description, image } = card
            return (
              <FourColumnFeatureCard key={id} image={image.responsiveImage} title={title} description={description} />
            )
          })}
        </StyledGrid>
      </Container>
    </StyledMainContainer>
  )
}
